export enum TipoPessoa{
  Aluno = 1,
  EquipeEscolar = 2,
  Outros = 3,
  Turma = 4
}